import React, { useState, useEffect } from 'react';
import './UserModal.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { HiOutlineMailOpen } from "react-icons/hi";
import { PiPhoneCallBold } from "react-icons/pi";
import { GiPalmTree } from "react-icons/gi";
import useScheduleAppointment from './useScheduleAppointment5';
//import axios from 'axios'; 


const UserModal = ({ isOpen, onClose }) => {
  const { scheduleAppointment, getAppointments, getBlockedTimes, loading, error, success, appointments, setSuccess } = useScheduleAppointment();
  const [name, setName] = useState('');
  //const [title, setTitle] = useState('');
  const [date, setDate] = useState(null);
  //const [description, setDescription] = useState('');
  const [message, setMessage] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [email, setEmail] = useState('');
  const [address, setAddress] = useState('');
  


  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('handleSubmit called');
    console.log('Data in handleSubmit:', { name, date, phoneNumber, email, address }); // Verify data
    console.log("date object: ", date); 
    console.log(date.toString());
    try {
      await scheduleAppointment({ name, date, phoneNumber, email, address });
      setName('');
      setDate(new Date());
      setPhoneNumber('');
      setAddress(''); 
      console.log('Appointment set', e);
      console.log('scheduleAppointment', scheduleAppointment);
    } catch (error) {
      console.error('Error in handleSubmit:', error);
    }
  };
  

  useEffect(() => {
    if (!isOpen) {
      // Reset state variables when modal is closed
      setName('');
      setDate(null);
      setPhoneNumber('');
      setEmail('');
      setAddress('');
      setSuccess(false);
    }
  }, [isOpen, setSuccess]);


  if (!isOpen) return null;

 

  const bookedDates = appointments()
    .map((appt) => new Date(appt.date))
    .filter((date) => !isNaN(date.getTime())) // Filter out invalid dates
    .map((date) => date.setHours(0, 0, 0, 0));

  const bookedTimesForDate = (selectedDate) => {
    if (!selectedDate) return [];
    return appointments()
      .map((appt) => new Date(appt.date))
      .filter((date) => !isNaN(date.getTime()) && date.toDateString() === selectedDate.toDateString());
  };

  const blockedDates = getBlockedTimes()
    .map((blocked) => new Date(blocked.date))
    .filter((date) => !isNaN(date.getTime())) // Filter out invalid dates
    .map((date) => date.setHours(0, 0, 0, 0));

  const blockedTimesForDate = (selectedDate) => {
    if (!selectedDate) return [];
    return getBlockedTimes()
      .map((blocked) => new Date(blocked.date))
      .filter((date) => !isNaN(date.getTime()) && date.toDateString() === selectedDate.toDateString());
  };

 

const isFullBlockedOrBooked = (date) => {
  if (!date) return false;

  const dayStart = new Date(date).setHours(8, 0, 0, 0); // Start at 8:00 AM
  const dayEnd = new Date(date).setHours(17, 0, 0, 0); // End at 5:00 PM
  let slotCount = 0;

  for (let time = new Date(dayStart); time < dayEnd; time.setHours(time.getHours() + 1)) {
      const timeString = time.toISOString();

      const isBooked = appointments().some(appt => {
          const apptTime = new Date(appt.date).toISOString().slice(0, 13);
          return apptTime === timeString.slice(0, 13);
      });

      const isBlocked = getBlockedTimes().some(blocked => {
          const blockedTime = new Date(blocked.date).toISOString().slice(0, 13);
          return blockedTime === timeString.slice(0, 13);
      });

      if (isBooked || isBlocked) {
          slotCount++;
      }
  }

  return slotCount >= 9; // 9 slots between 8AM and 5PM with 1 hour intervals
};







  return (
    <div className="modal-overlay">
      <div id='content_wrapper2'>
        <button className="close-button1" onClick={onClose}>
          &times;
        </button>
      <div id='modal_text_10_container'>
        <div id='modal_text_10'>
          <div id='icon_modal_text_10'>
              <div id='modal_text_10_text2_1'><h1> - - - - - -&nbsp;&nbsp;</h1>
              </div><div id='modal_text_10_half_icon2'><GiPalmTree /></div>
              <div id='modal_text_10_text2_2'><h1>&nbsp;- - - - - -</h1></div>
          </div>
          <div id='icon_modal_text_10_subtext'>
              <h1>Get a Free Estimate!</h1>
              <p><strong>Sam's Tree Service</strong> is committed to top-quality tree care, backed 
                by outstanding customer reviews. Whether you need tree removal, trimming, or stump 
                grinding, our experts are ready to help. <strong>Request an appointment 
                today</strong> to get a free, no-obligation estimate tailored to your needs!!</p>
          </div>
        </div>
          <div id='contact_box'>
            <div id='Schedule_subdiv1' className='Schedule_subdiv' onClick={() => window.location.href = 'mailto:email@email.com'}
                  style={{ cursor: 'pointer' }}>
                <div className='circle_icon'><HiOutlineMailOpen /></div>
                <div className='Schedule_subdiv_text'>
                  <h1>Email</h1>
                  <p>contact@samstreeservice.com</p>
                </div>
            </div>
            <div className='Schedule_subdiv' onClick={() => window.location.href = 'tel:941-879-8853'}
                  style={{ cursor: 'pointer' }}>
                <div className='circle_icon'><PiPhoneCallBold /></div>
                <div className='Schedule_subdiv_text'>
                  <h1>Phone</h1>
                  <p>941-879-8853</p>
                </div>
            </div>
          </div>
        </div>
      <div className="modal-content">
        
        {/*<h1>Request An Appointment</h1>*/}
        <form id='form' onSubmit={handleSubmit}>
          <input
            id='input_name'
            type="text"
            placeholder="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
          <DatePicker
            selected={date}
            onChange={(newDate) => setDate(newDate)}
            showTimeSelect
            dateFormat="MMMM d, yyyy h:mm aa"
            placeholderText="Select Date and Time"
            highlightDates={[
              ...bookedDates.map(date => new Date(date)),
              ...blockedDates.map(date => new Date(date))
          ]}
          excludeTimes={date ? [
              ...bookedTimesForDate(date),
              ...blockedTimesForDate(date),
          ] : []}
            minTime={new Date(0, 0, 0, 8, 0)} // 8:00 AM
            maxTime={new Date(0, 0, 0, 17, 0)} // 5:00 PM
            timeIntervals={60} // 60 minutes (1 hour)
            filterTime={(time) => {
              const hours = time.getHours();
                return hours >= 8 && hours < 17;
            }}

            
            renderDayContents={(day, date) => {
              if (isFullBlockedOrBooked(date)) {
                  return (
                      <div style={{ backgroundColor: 'red', color: 'white', width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '5px' }}>
                          {day}
                      </div>
                  );
              }
              return day;
          }}
            required
          />
          <input
            type="tel"
            placeholder="Phone#"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
            required
          />
          <input
            type="email"
            placeholder="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type="address"
            placeholder="Address"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            required
          />
          <button id='submit_button' type="submit" disabled={loading}>
            {loading ? 'Requesting...' : 'Request An Appointment'}
          </button>
        </form>
        
      <div id='appoinment_modal_display'>
        {/*<h3>Request An Appointment</h3>*/}
        <ul>
          {appointments().map((appointment) => (
            <li key={appointment.id}>
              <strong>{appointment.name}</strong> - {new Date(appointment.date).toLocaleString()}
              <p>Phone: {appointment.phoneNumber}</p>
              <p>Address: {appointment.address}</p>
            </li>
          ))}
        </ul>
      </div>
      <div id='appoinment_modal_display2'>
        {error && <p style={{ color: 'red' }}>Error: {error.message}</p>}
        {success && <p style={{ color: 'green' }}>Appointment request successfully! A representative will contact you soon.</p>}
      </div>
        
        
      </div>
      <div id='contact_box2'>
            <div id='Schedule_subdiv1' className='Schedule_subdiv' onClick={() => window.location.href = 'mailto:email@email.com'}
                  style={{ cursor: 'pointer' }}>
                <div className='circle_icon'><HiOutlineMailOpen /></div>
                <div className='Schedule_subdiv_text'>
                  <h1>Email</h1>
                  <p>contact@samstreeservice.com</p>
                </div>
            </div>
            <div className='Schedule_subdiv' onClick={() => window.location.href = 'tel:941-879-8853'}
                  style={{ cursor: 'pointer' }}>
                <div className='circle_icon'><PiPhoneCallBold /></div>
                <div className='Schedule_subdiv_text'>
                  <h1>Phone</h1>
                  <p>941-879-8853</p>
                </div>
            </div>
          </div>
     
      </div>
    </div>
  );
};

export default UserModal;
